import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { IncomeCreateDataPage } from "../income-create/income-create-data/income-create-data";
import { ExpensesCreateDataPage } from "../expenses-create/expenses-create-data/expenses-create-data";
import { IncomeExpensesServices } from "../services";
import { ProvidersCreateDataPage } from "../../providers/providers-create/providers-create-data/providers-create-data";
import { CustomersListPage } from "../../customers/customers-list/customers-list";
import { InvoicesServices } from "../../invoices/services";
import { InvoicesListPage } from "../../invoices/invoices-list/invoices-list";
import * as moment from 'moment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ExportServices } from '../../services/exportServices';
import { ConfigurationServices } from '../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { ImportExcelPage } from '../../components/import-excel/import-excel';
import { CustomersCreateInfoPage } from '../../customers/customers-create/customers-create-info/customers-create-info';
import { SelectBetweenDatetime } from '../../components/popups/select-between-datetime/select-between-datetime';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the IncomeExpensesListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-income-expenses-list',
  templateUrl: 'income-expenses-list.html',
})
export class IncomeExpensesListPage {

  chart: any;
  inexp: any;
  valueChanges: any;
  date_first: any;
  date_last: any;
  total_income = 0;
  total_expenses = 0;
  total_tips = 0;
  neto = 0;
  total_tax = 0;
  loader_totals: boolean = true;
  loader_chart_ie6months: boolean = true;

  element_type = 'income';
  searchbar_text: string = '';

  loader_totals_tickets_income: boolean = true;
  totals_tickets_income: any = [];
  totals_tickets_amount: any;

  //datatable
  sorts = [
    { prop: 'date', dir: 'asc' },
    { prop: 'number', dir: 'asc' },
    { prop: 'concept', dir: 'asc' },
    { prop: 'payment_method', dir: 'asc' },
    { prop: 'irpf_percentage', dir: 'asc' },
    { prop: 'total', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public incomeExpensesServices: IncomeExpensesServices,
    public globals: Globals,
    public invoicesServices: InvoicesServices,
    public toastCtrl: ToastController,
    public http: HttpClient,
    public exportServices: ExportServices,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService,
    public modalCtrl: ModalController) {

    this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - List', this.globals.restaurant.email, 'View', 'List income expenses', 'Income/Expenses', '');

    //a partir de la fecha en la que estamos nos da el primer y ultimo dia del trimestre(quarter)
    this.date_first = moment().quarter(moment().quarter()).startOf('quarter').format("YYYY-MM-DDTHH:mm:ss");
    this.date_last = moment().quarter(moment().quarter()).endOf('quarter').format("YYYY-MM-DDTHH:mm:ss");

  }

  // #region INIT

  ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-ingresos-gastos')
    });
    loadingPopup.present();
    //
    this.initAll();
    loadingPopup.dismiss();

  }
  async initAll() {
    //grafica
    if (this.globals.checkLimitsByLicense('incomes_expenses', 'analytics')) {
      this.analyticsGetIE6Months();
    } else {
      this.loader_chart_ie6months = false;
    }
    //funcion que calcula todo
    this.getIEListAndCalculate();
    //recuperem llistes
    //this.invoicesServices.getInvoicesPending(this.globals.restaurant_uid);

    this.incomeExpensesServices.incomesexpensesSearch(this.incomeExpensesServices.incomesexpenses_searchbar_text);
  }

  // #region CHARTS

  public chartIE6MonthsLabels: string[];
  public chartIE6MonthsData: any;
  public chartIE6MonthsType: string = 'bar';
  public chartIE6MonthsOptions: any = {
    legend: {
      display: false,
      position: 'top',
    },
    scales: {
      xAxes: [
        {
          categorySpacing: 0
        }],

      yAxes: [
        {
          type: "linear",
          display: true,
          position: "left",
        }]
    },
    maintainAspectRatio: false,
  };

  public chartColors: Array<any> = [
    { // Ingresos
      backgroundColor: "rgb(123, 198, 242)"
    },
    { // Gastos
      backgroundColor: "rgb(250, 159, 181)"
    }];


  // #region FUNCIONES
  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('general-ingresos-gastos'),
      date_first: this.date_first,
      date_last: this.date_last,
      cash_bool: false,
      income_bool: true,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.date_first = data.date_first;
        this.date_last = data.date_last;
        //
        this.getIEListAndCalculate();
      }
    });
    profileModal.present();
  }

  async getIEListAndCalculate() {
    //init
    //var total_income_tax = 0;
    //var total_expenses_tax = 0;
    this.total_income = 0;
    this.total_expenses = 0;
    this.neto = 0;
    this.total_tax = 0;
    this.incomeExpensesServices.getPagesIncomeExpenses(this.element_type, this.date_first, this.date_last);
    this.getTotalsIncomeExpenses(this.date_first, this.date_last);
  }

  taxOfValue(value, tax) {
    var tax_return = (value * parseFloat(tax)) / 100;
    return tax_return;
  }

  async getTicketsBetweenDates(date_first, date_last) {
    this.totals_tickets_income = [];

    return new Promise((resolve, reject) => {
      this.http.post(this.globals.analytics_path + 'biclosecash/get_tickets_list', {
        public_key: this.globals.public_key,
        uid_cash: 'all',
        datetime_init: new Date(date_first),
        datetime_final: new Date(date_last),
      }, {}).subscribe(async data => {
        const tickets = data['tickets'];

        // Convertir tickets al formato de income para el excel
        if (tickets && tickets.length > 0) {
          for (let ticket of tickets) {
            // Calcular IVA y totales desde la lista de productos
            let total = 0;
            let base = 0;
            let taxPercentage = 0;

            if (ticket.list && Object.keys(ticket.list).length > 0) {
              const taxData = this.globals.showIvaProducts(ticket.list);
              total = taxData.total;
              base = taxData.subtotal;

              // Obtener el porcentaje de IVA predominante
              if (taxData.taxs && taxData.taxs.length > 0) {
                // Usar el IVA del elemento con mayor importe
                const mainTax = taxData.taxs.reduce((prev, current) =>
                  (prev.total > current.total) ? prev : current
                );
                taxPercentage = mainTax.tax;
              }
            } else if (ticket.amount) {
              // Si no hay lista de productos, usar el amount y tax del ticket
              total = ticket.amount;
              const ticketTax = ticket.tax || this.globals.RESTAURANT_TAX || 0;
              base = this.globals.createSubTotal(total, ticketTax);
              taxPercentage = ticketTax;
            }

            // Añadir propina al total si existe
            if (ticket.tip) {
              total = Number(total) + parseFloat(ticket.tip);
            }

            const ticketIncome = {
              date: ticket.date,
              number: ticket.number || ticket.UID,
              concept: 'Venta ticket ' + (ticket.number || ''),
              payment_method: this.globals.returnPaymentType(ticket.payment_type || 'not specified'),
              base: base,
              tax: taxPercentage,
              total: total
            };
            this.totals_tickets_income.push(ticketIncome);
          }
        }
        resolve(true);
      }, err => {
        console.error('Error obteniendo tickets:', err);
        resolve(false);
      });
    });
  }

  /**
   * Convierte un Timestamp de Firestore a Date de JavaScript
   * Maneja tanto el formato {_seconds, _nanoseconds} como el objeto Timestamp completo
   */
  convertTimestampToDate(timestamp: any): Date {
    if (!timestamp) {
      return null;
    }

    // Si tiene el método toDate() (Timestamp completo de Firestore)
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
      return timestamp.toDate();
    }

    // Si tiene _seconds (formato interno de Timestamp)
    if (timestamp._seconds !== undefined) {
      return new Date(timestamp._seconds * 1000);
    }

    // Si tiene seconds (otro formato de Timestamp)
    if (timestamp.seconds !== undefined) {
      return new Date(timestamp.seconds * 1000);
    }

    // Si ya es un Date, devolverlo tal cual
    if (timestamp instanceof Date) {
      return timestamp;
    }

    // Si no se puede convertir, devolver null
    return null;
  }

  async exportIE() {
    //loader
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();

    //init 
    var data = [];
    var _income = [];
    var _expense = [];

    //
    if (this.date_first <= this.date_last) {
      //recuperamos ingresos y gastos entre fechas y partimos las listas
      var returned = await this.incomeExpensesServices.getIncomeExpensesBetweenDates(this.globals.restaurant_uid, this.date_first, this.date_last);
      var _incomes = returned[0];
      var _expenses = returned[1];

      //recuperamos tickets de venta del TPV
      await this.getTicketsBetweenDates(this.date_first, this.date_last);

      //recorremos ingresos
      for (let income of _incomes) {
        // Convertir Timestamp a Date
        const fechaConvertida = this.convertTimestampToDate(income.date);

        //crear lista y añadir los ingresos
        var _array_i = {
          [this.translate.instant('general-fecha')]: fechaConvertida,
          [this.translate.instant('general-numero')]: income.number,
          [this.translate.instant('general-concepto')]: income.concept,
          [this.translate.instant('general-metodo-pago')]: income.payment_method ? this.globals.getPaymentMethodInex(income.payment_method) : '',
          [this.translate.instant('general-base')]: income.base.toFixed(2),
          [this.translate.instant('general-iva') + ' (%)']: income.tax,
          [this.translate.instant('income-expenses-importe-iva')]: this.taxOfValue(income.base, income.tax).toFixed(2),
          [this.translate.instant('general-total')]: income.total.toFixed(2),
        };

        _income.push(_array_i);

      }
      //income de tickets informe venta
      for (let income of this.totals_tickets_income) {
        // Convertir Timestamp a Date
        const fechaConvertida = this.convertTimestampToDate(income.date);

        //crear lista y añadir los ingresos
        var _array_j = {
          [this.translate.instant('general-fecha')]: fechaConvertida,
          [this.translate.instant('general-numero')]: income.number,
          [this.translate.instant('general-concepto')]: income.concept,
          [this.translate.instant('general-metodo-pago')]: income.payment_method || '',  // Ya viene traducido de getTicketsBetweenDates
          [this.translate.instant('general-base')]: income.base.toFixed(2),
          [this.translate.instant('general-iva') + ' (%)']: income.tax,
          [this.translate.instant('income-expenses-importe-iva')]: this.taxOfValue(income.base, income.tax).toFixed(2),
          [this.translate.instant('general-total')]: income.total.toFixed(2),
        };

        _income.push(_array_j);
      }

      //formatar datos para excel ingresos
      var _array_data_income = {
        name: 'ingresos',
        inexp: _income,
      };

      data.push(_array_data_income);

      //recorer gastos
      for (let expense of _expenses) {
        // Convertir Timestamp a Date
        const fechaConvertida = this.convertTimestampToDate(expense.date);

        var irpf_perc = expense.irpf_percentage || 0;
        var irpf_amt = expense.irpf_amount || 0;
        
        // El IVA se calcula sobre la base original, no sobre la base después de IRPF
        var iva_amount = this.taxOfValue(expense.base, expense.tax);

        //crear lista y añadir los gastos
        var _array_e = {
          [this.translate.instant('general-fecha')]: fechaConvertida,
          [this.translate.instant('general-numero')]: expense.number,
          [this.translate.instant('income-expenses-razon-social')]: expense.business_name,
          [this.translate.instant('general-concepto')]: expense.concept,
          [this.translate.instant('general-metodo-pago')]: expense.payment_method ? this.globals.getPaymentMethodInex(expense.payment_method) : '',
          [this.translate.instant('general-base')]: expense.base.toFixed(2),
          [this.translate.instant('general-irpf') + ' (%)']: irpf_perc.toFixed(2),
          [this.translate.instant('general-irpf-importe')]: irpf_amt.toFixed(2),
          [this.translate.instant('general-iva') + ' (%)']: expense.tax,
          [this.translate.instant('income-expenses-importe-iva')]: iva_amount.toFixed(2),
          [this.translate.instant('general-total')]: expense.total.toFixed(2),
        };

        _expense.push(_array_e);

      }
      //formatar datos para excel gastos
      var _array_data_expense = {
        name: 'gastos',
        inexp: _expense,
      };

      data.push(_array_data_expense);

      this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Export tax - View', this.globals.restaurant.email, 'View', 'Export tax', 'Income/Expenses', '');

      //
      loadingPopup.dismiss();
      //llamar funcion exportar
      this.exportServices.exportAsExcelIncomeExpenses(data, 'ingresosygastos');

    } else {
      loadingPopup.dismiss();
      //fechas mal lanzar toast
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-rango-fechas-correcto'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }


  changeType(type) {
    this.element_type = type;
    this.incomeExpensesServices.getPagesIncomeExpenses(this.element_type, this.date_first, this.date_last);
  }


  soGenerateInvoice() {
    let cssClasses = {};
    if (!this.globals.so_mobile) {
      cssClasses = {
        'col-3': true,
      }
    } else {

      cssClasses = {
        'col-12': true,
      }
    }
    return cssClasses;
  }

  // #region FUNCIONES A NODE

  async analyticsGetIE6Months() {
    //iniciamos la fecha con 6 meses atras
    var date = moment().subtract(5, 'months').format("YYYY/MM/DD")
    //llamamos a la funcion del node
    this.http.post(this.globals.analytics_path + 'inexp/income_expenses_graphic_six_months',
      {
        public_key: this.globals.public_key,
        date: date,
      }, {})
      .subscribe(res => {
        //llenamos los datos
        this.chartIE6MonthsData =
          [{
            label: this.translate.instant('general-ingresos'),
            data: res['array_income'],
            barPercentage: 1
          }, {
            label: this.translate.instant('general-gastos'),
            data: res['array_expenses'],
            barPercentage: 1
          }];
        //traducimos los meses
        var arr_moths = [];
        for (let month of res['array_months']) {
          arr_moths.push(this.translate.instant(this.globals.returnTag2TranslateMoth(month)));
        }
        this.chartIE6MonthsLabels = arr_moths;
        //seteamos al loader que esta todo cargado
        this.loader_chart_ie6months = false;
      },
        err => {
          this.loader_chart_ie6months = false;
        });
  }

  async getTotalsIncomeExpenses(date_first, date_last) {
    this.loader_totals = true;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('datetime_init', date_first)
      .set('datetime_final', date_last);
    await this.http.post(this.globals.analytics_path + 'inexp/get_totals_income_expenses', params, {})
      .subscribe(async res => {
        this.total_income = res['total_income'];
        this.total_expenses = res['total_expenses'];
        this.total_tips = res['total_tips'];
        this.neto = res['neto'];
        this.total_tax = res['total_tax'];
        this.loader_totals = false;
      },
        err => {
          this.loader_totals = false;
        });
  }

  // #region NAVCTRL

  createIncome() {
    this.navCtrl.push(IncomeCreateDataPage);
  }

  createExpenses() {
    this.navCtrl.push(ExpensesCreateDataPage);
  }

  createCustomers() {
    this.navCtrl.push(CustomersCreateInfoPage);
  }

  createproviders() {
    this.navCtrl.push(ProvidersCreateDataPage);
  }

  openCustomersList() {

    if (!this.globals.checkLimitsByLicense('sales', 'customers')) {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      this.navCtrl.push(CustomersListPage);
    }
  }

  openInvoicesList() {
    this.navCtrl.push(InvoicesListPage);
  }

  openView(uid, type, value) {
    if (type == 'income') {

      this.navCtrl.push(IncomeCreateDataPage, {
        update_state: true,
        income_uid: value.UID,
        number: value.number,
        date: value.date,
        concept: value.concept,
        base: value.base,
        tax: value.tax,
        total: value.total,
        payment_method: value.payment_method,
      });

    } else {
      // Asegurar que IRPF esté inicializado para gastos existentes sin estos campos
      var irpf_perc = (value.irpf_percentage !== null && value.irpf_percentage !== undefined) ? value.irpf_percentage : 0;
      var irpf_amt = (value.irpf_amount !== null && value.irpf_amount !== undefined) ? value.irpf_amount : 0;
      
      this.navCtrl.push(ExpensesCreateDataPage, {
        update_state: true,
        expenses_uid: value.UID,
        number: value.number,
        date: value.date,
        concept: value.concept,
        base: value.base,
        tax: value.tax,
        total: value.total,
        business_name: value.business_name,
        provider_uid: value.provider_uid,
        payment_method: value.payment_method,
        category: value.category,
        payment: value.payment,
        irpf_percentage: irpf_perc,
        irpf_amount: irpf_amt
      })
    }

  }

  importIncomes(type) {
    this.navCtrl.push(ImportExcelPage, {
      type: type
    });
  }

  importExpenses(type) {
    this.navCtrl.push(ImportExcelPage, {
      type: type
    });
  }

  clickElement(event) {
    if (event.type == 'click') {
      if (this.element_type == 'income') {
        this.navCtrl.push(IncomeCreateDataPage, {
          update_state: true,
          income_uid: event.row.UID,
          number: event.row.number,
          date: event.row.date,
          concept: event.row.concept,
          base: event.row.base,
          tax: event.row.tax,
          total: event.row.total,
          payment_method: event.row.payment_method,
        });
      } else {
        // Asegurar que IRPF esté inicializado para gastos existentes sin estos campos
        var irpf_perc = (event.row.irpf_percentage !== null && event.row.irpf_percentage !== undefined) ? event.row.irpf_percentage : 0;
        var irpf_amt = (event.row.irpf_amount !== null && event.row.irpf_amount !== undefined) ? event.row.irpf_amount : 0;
        
        this.navCtrl.push(ExpensesCreateDataPage, {
          update_state: true,
          expenses_uid: event.row.UID,
          number: event.row.number,
          date: event.row.date,
          concept: event.row.concept,
          base: event.row.base,
          tax: event.row.tax,
          total: event.row.total,
          business_name: event.row.business_name,
          provider_uid: event.row.provider_uid,
          payment_method: event.row.payment_method,
          category: event.row.category,
          payment: event.row.payment === undefined ? false : event.row.payment,
          irpf_percentage: irpf_perc,
          irpf_amount: irpf_amt
        })
      }
    }
  }

  onSort(event) {
    var incomesexpenses_array = this.incomeExpensesServices.incomesexpenses_array_filtered;

    switch (event.column.name) {
      case 'date':
        if (event.newValue == 'asc') {
          incomesexpenses_array.sort((a, b) => this.globals.timestampToDate(a.date).localeCompare(this.globals.timestampToDate(b.date)));
        } else {
          incomesexpenses_array.sort((a, b) => this.globals.timestampToDate(b.date).localeCompare(this.globals.timestampToDate(a.date)));
        }
        break;
      case 'number':
        if (event.newValue == 'asc') {
          incomesexpenses_array.sort((a, b) => a.number.localeCompare(b.number));
        } else {
          incomesexpenses_array.sort((a, b) => b.number.localeCompare(a.number));
        }
        break;
      case 'concept':
        if (event.newValue == 'asc') {
          incomesexpenses_array.sort((a, b) => a.concept.toLowerCase().localeCompare(b.concept.toLowerCase()));
        } else {
          incomesexpenses_array.sort((a, b) => b.concept.toLowerCase().localeCompare(a.concept.toLowerCase()));
        }
        break;
      case 'payment_method':
        if (event.newValue == 'asc') {
          incomesexpenses_array.sort((a, b) => a.payment_method.localeCompare(b.payment_method));
        } else {
          incomesexpenses_array.sort((a, b) => b.payment_method.localeCompare(a.payment_method));
        }
        break;
      case 'irpf_percentage':
        if (event.newValue == 'asc') {
          incomesexpenses_array.sort((a, b) => {
            var irpf_a = (a.irpf_percentage !== null && a.irpf_percentage !== undefined) ? a.irpf_percentage : 0;
            var irpf_b = (b.irpf_percentage !== null && b.irpf_percentage !== undefined) ? b.irpf_percentage : 0;
            return irpf_a - irpf_b;
          });
        } else {
          incomesexpenses_array.sort((a, b) => {
            var irpf_a = (a.irpf_percentage !== null && a.irpf_percentage !== undefined) ? a.irpf_percentage : 0;
            var irpf_b = (b.irpf_percentage !== null && b.irpf_percentage !== undefined) ? b.irpf_percentage : 0;
            return irpf_b - irpf_a;
          });
        }
        break;
      case 'total':
        if (event.newValue == 'asc') {
          incomesexpenses_array.sort((a, b) => a.total - b.total);
        } else {
          incomesexpenses_array.sort((a, b) => b.total - a.total);
        }
        break;
    }

    this.incomeExpensesServices.incomesexpenses_array_filtered = incomesexpenses_array;
  }

}



// WEBPACK FOOTER //
// ./src/pages/income-expenses/income-expenses-list/income-expenses-list.ts